module.exports = __webpack_public_path__ + "images/success-68392a.svg";